import { ChatFixture, StreamChunk } from './types';

/**
 * Journey 3 — document-reader.
 *
 * Simulates an intake of 5 PDFs: upload events, manifest population, tags,
 * and a consolidated summary reply.
 */

export const documentFixtures = [
  {
    filename: 'employment-agreement.pdf',
    words: 4821,
    tags: ['employment', 'contract', 'EN'],
    summary:
      'Three-year at-will employment agreement for a senior paralegal. Includes arbitration clause, ' +
      'confidentiality provisions, and a non-solicit (no non-compete).',
  },
  {
    filename: 'demand-letter-template.pdf',
    words: 1204,
    tags: ['template', 'demand-letter', 'EN'],
    summary:
      'Firm-standard demand letter template for workers compensation retaliation claims. Contains ' +
      'citation placeholders and a 14-day response window.',
  },
  {
    filename: 'i589-application.pdf',
    words: 7120,
    tags: ['immigration', 'I-589', 'asylum', 'ES'],
    summary:
      'Partially completed I-589 asylum application for a Honduran family of four. Missing Part C ' +
      'supplemental statements and medical documentation.',
  },
  {
    filename: 'medical-records.pdf',
    words: 2896,
    tags: ['medical', 'workers-comp', 'EN'],
    summary:
      'Kaiser Permanente treatment records spanning 2023-04-01 through 2024-02-12. Documents lumbar ' +
      'strain, impingement syndrome, and prescribed physical therapy.',
  },
  {
    filename: 'court-filing.pdf',
    words: 3402,
    tags: ['litigation', 'court-filing', 'EN'],
    summary:
      'Superior Court complaint (Alameda County) alleging wrongful termination and failure to pay ' +
      'final wages under Labor Code § 201. Case no. RG-24-0912.',
  },
];

const manifestEvents: StreamChunk[] = documentFixtures.flatMap((doc, i) => [
  {
    delta: '',
    delayMs: 180,
    event: 'file_upload',
    data: { index: i + 1, filename: doc.filename, bytes: doc.words * 6 },
  },
  {
    delta: '',
    delayMs: 320,
    event: 'file_parsed',
    data: { index: i + 1, filename: doc.filename, wordCount: doc.words, tags: doc.tags },
  },
]);

const summaryLines = documentFixtures.map(
  (doc, i) => `  ${i + 1}. ${doc.filename} — [${doc.tags.join(', ')}] — ${doc.summary}`,
);

export const documentReaderFixture: ChatFixture = {
  id: 'document-reader',
  userQuery: 'Read all 5 of these files and give me a consolidated intake summary.',
  steps: ['uploading', 'parsing', 'tagging', 'summarizing', 'complete'],
  chunks: [
    { delta: '', delayMs: 200, event: 'thinking', data: { label: 'Reading 5 documents...' } },
    ...manifestEvents,
    { delta: '', delayMs: 160, event: 'thinking', data: { label: 'Generating summary...' } },
    {
      delta: 'Processed 5 documents. Here is the intake summary:\n\n',
      delayMs: 80,
    },
    ...summaryLines.map((line) => ({ delta: line + '\n', delayMs: 80 })),
    {
      delta:
        '\nNext steps: (a) complete Part C of the I-589, (b) chase missing PT discharge notes, ' +
        '(c) draft the retaliation demand letter from the template.',
      delayMs: 120,
    },
  ],
};

export default documentReaderFixture;
